import { Language, Translations } from './translationsTypes';

export const getConfig = async (
  language: Language
): Promise<{
  translations: Translations;
}> => {
  const url = `${import.meta.env.VITE_OPENAPI_BASE_URL}/v1/translations/constellation?language=${language}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`Network response was not ok with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching ${url}: ${error instanceof Error ? error.message : error}`);
  }
};
